//import Swiper from 'swiper';
import Alpine from "alpinejs";
import request from 'oc-request';
import sticky from 'alpinejs-sticky'
// import ReadSmore from 'read-smore'
import swiper from './swiper.js';
import fovorite from './fovorite.js';
import toggle from './toggle.js';
import cart from './cart.js';
import tabs from './tabs.js';
import UrlGeneration from "./url.js";
import mask from '@alpinejs/mask'
import Clipboard from "@ryangjchandler/alpine-clipboard";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Alpine.plugin(Clipboard);
Alpine.plugin(mask);
Alpine.plugin(sticky)

document.addEventListener('alpine:init', () => {

    Alpine.data('swiper', swiper);
    Alpine.data('fovorite', fovorite);
    Alpine.data('toggle', toggle);
    Alpine.data('tabs', tabs);
    Alpine.data('cart', cart);

    Alpine.data('templateData', (data) => ({

        slide: false,
        modal: false,
        mobilenav: false,
        isShowing: false,
        feildsCount: 0,
        
        triggers: {
            ['x-init']() {
                UrlGeneration.init();

                Fancybox.bind('[data-fancybox]', {
                    //
                });
            }
        },
        catalogUpdate(partial = 'articles/category/_list') {
            this.request('ProductList::onAjaxRequest', {
                update: { ['articles/category/_list']: '.js-article-list' },
                loading: '.preloader-selector'
            })
        },
        changePage(page) {
            UrlGeneration.set('page', page);
            UrlGeneration.update();

            this.catalogUpdate();
        },
        changeSort(sort) {
            UrlGeneration.set('sort', sort);
            UrlGeneration.update();

            this.catalogUpdate();
        },
        filterBaseUrl(url) {
            UrlGeneration.setBaseUrl(url);
        },
        changeProperty() {
            const formData = new FormData(this.$refs.article_form);
            // Create an array to hold the name/value pairs
            const feilds = [];
            let feildsCount = 0;

            for(item in UrlGeneration.obParamList) {
                if (item.includes('property')) {
                    UrlGeneration.remove(item);
                }
            }

            // Add each name/value pair to the array
            for (const [name, value] of formData) {
                if (!Array.isArray(feilds[name])) {
                    feilds[name] = [value];
                    feildsCount++;
                } else {
                    feilds[name].push(value); 
                    feildsCount++;
                }
            }

            for (var item in feilds) {
                UrlGeneration.set(item, feilds[item]);
            }
            
            this.setFilterCounter(feildsCount-2);
            UrlGeneration.update();
            this.catalogUpdate();
        },

        setFilterCounter(num) {
            this.feildsCount = num;
        },
        
        slideOpen(partial, target, data = null) {
            this.slide = false;

            this.fetchPartial(partial, target, data);

            this.slide = true;
        },

        slideClose() { this.slide = false },
        isSlideOpen() { return this.slide === true },

        modalOpen() { this.modal = true },
        modalClose() { 
            this.modal = false;
        },
        
        isModalOpen() { return this.modal === true },

        escape() {
            this.slideClose();
        },

        fetchPartial(partial, target, data) {
            this.request('Viewed::onPartial', {
                data: data,
                update: { [partial]: target },
                loading: '.preloader-selector'
            });
        },

        request(hendler, options) {
            return request.sendData(hendler, options);
        },

        jsAuthLogout() {
            this.request('Logout::onAjax', {
                loading: '.preloader-selector'
            });
        }
    }));
});

Alpine.start();
